import * as z from 'zod';

export type BillingSimulationFormSchemaValues = z.infer<typeof billingSimulationFormSchema>;

export const billingSimulationFormSchema = z
    .object({
        start_date: z.string().nonempty(),
        end_date: z.string().nonempty(),
        discount_policy_ids: z.array(z.string()),
        voucher_type_ids: z.array(z.string()),
        // Keyed by service plan item id. An item left out is priced at the plan's base price,
        // so blank inputs are stripped before the request rather than sent as 1.
        item_coefficients: z.record(z.string(), z.string()),
    })
    .refine((data) => new Date(data.start_date) <= new Date(data.end_date), {
        path: ['end_date'],
        message: 'End date must be on or after start date.',
    });
